import moment from 'moment'
import 'moment-duration-format'

export default {
  filters: {
    translate: (key, langObject) => {
      if (!langObject || typeof langObject !== 'object') {
        return key
      }
      return langObject[key] || key
    },
    otpFormat: otp => {
      // 6 digit OTP - add spaces every 3 digits
      otp = otp.toString()
      otp = otp.replace(/(\d{3})(?=\d)/g, '$1 ')
      otp = otp.trim()
      return otp
    },
    printerFromPayments: payments => {
      if (Array.isArray(payments) && payments.length > 0 && typeof payments[0].printerNumber !== 'undefined') {
        return payments[0].printerNumber
      }
      return 'n/a'
    },
    terminalFromPayments: payments => {
      if (Array.isArray(payments) && payments.length > 0 && typeof payments[0].TID !== 'undefined') {
        return payments[0].TID
      }
      return 'n/a'
    },
    readerDict: val => {
      let res
      switch (val) {
        case 'B':
          res = 'Contactless'
          break
        case 'RFI':
          res = 'Contactless'
          break
        case 'C':
          res = 'Magstripe'
          break
        case 'P':
          res = 'ICC'
          break
        case 'S':
          res = 'ICC'
          break
        case '?':
          res = 'Unknown'
          break
      }
      return res
    },
    authMethodDict: val => {
      let res
      switch (val) {
        case 'A':
          res = 'PIN'
          break
        case '?':
          res = 'NOPIN'
          break
      }
      return res
    },
    statusDict: val => {
      let res
      switch (val) {
        case 'success':
          res = 'notreversed'
          break
        case 'reversalError':
          res = 'notreversed'
          break
        case 'canceled':
          res = 'reversed'
          break
        case 'failed':
          res = 'failed'
          break
        case 'printed':
          res = 'printed'
          break
        case 'printError':
          res = 'printError'
          break
      }
      return res
    },
    paymentClass: status => {
      let className
      switch (status) {
        case 'failed':
          className = 'bg-info'
          break
        case 'printed':
          className = 'bg-success'
          break
        case 'canceled':
          className = 'bg-warning'
          break
        case 'success':
          className = 'bg-danger'
          break
        case 'reversalError':
          className = 'bg-danger'
          break
        case 'printError':
          className = 'bg-primary'
          break
      }
      return className
    },
    statusSummaryClass: val => {
      let className
      switch (val) {
        case 'ok':
          className = 'bg-success'
          break
        case 'error':
          className = 'bg-danger'
          break
      }
      return className
    },
    statusOperationClass: val => {
      let className
      switch (val) {
        case 'operational':
          className = 'bg-success'
          break
        case 'initializing':
          className = 'bg-primary'
          break
        case 'maintenance':
          className = 'bg-warning'
          break
      }
      return className
    },
    statusFailureStateClass: val => {
      let className
      switch (val) {
        case 'fine':
          className = 'bg-success'
          break
        case 'warning':
          className = 'bg-warning'
          break
        case 'malfunction':
          className = 'bg-danger'
          break
      }
      return className
    },
    statusPowerClass: val => {
      let className
      switch (val) {
        case 'online':
          className = 'bg-success'
          break
        case 'stanby':
          className = 'bg-warning'
          break
        case 'standby':
          className = 'bg-warning'
          break
        case 'disabled':
          className = 'bg-danger'
          break
      }
      return className
    },
    pageNum: page => {
      return (page + 1)
    },
    formatDuration: unixtimestamp => {
      if (typeof unixtimestamp === 'undefined') return '-'
      return moment.duration(unixtimestamp, 'ms').format()
    },
    formatDurationDays: (unixtimestamp, lang) => {
      const days = (lang === 'pl') ? 'dni' : 'days'
      if (typeof unixtimestamp === 'undefined' || unixtimestamp === 0) return '-'
      return moment.duration(unixtimestamp, 'ms').format(`dd [${days}] HH:mm`, { trim: false })
    },
    formatDateTime: unixtimestamp => {
      return moment(unixtimestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    screenShotDateTime: sshot => {
      if (sshot) {
        return (sshot[0]) ? moment(sshot[0].updatedAt).format('YYYY-MM-DD HH:mm:ss') : ''
      }
      return ''
    },
    statusDateTime: status => {
      let key = Object.keys(status)[0]
      if (typeof status[key] === 'undefined') return '-'
      return moment(status[key].updatedAt).format('YYYY-MM-DD HH:mm:ss')
    },
    hwStatus: (device, lang) => {
      let status = ''
      if (device.kiosk_status && device.kiosk_status !== 'operational') {
        // Sanitize kiosk_status to prevent XSS
        const sanitizedStatus = String(device.kiosk_status).replace(/[<>"'&]/g, (match) => {
          const escapeMap = {
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '&': '&amp;'
          }
          return escapeMap[match]
        })
        status += '<br>' + sanitizedStatus.toUpperCase()
      }
      if (device.failure && device.failure.errors) {
        device.failure.errors.forEach((error) => {
          // Sanitize error descriptions to prevent XSS
          const sanitizedDesc = error.status_description ? String(error.status_description).replace(/[<>"'&]/g, (match) => {
            const escapeMap = {
              '<': '&lt;',
              '>': '&gt;',
              '"': '&quot;',
              "'": '&#x27;',
              '&': '&amp;'
            }
            return escapeMap[match]
          }) : ''

          if (lang === 'pl') {
            status += '<br>• ' + sanitizedDesc
          } else {
            const translatedDesc = translate(sanitizedDesc)
            status += '<br>• ' + translatedDesc
          }
        })
      }
      if (status.length > 0) {
        status = ':' + status
      }
      return status
    },
    translateError: (errorStatus, lang) => {
      let status = ''
      if (lang === 'pl') {
        status = errorStatus
      } else {
        status = translate(errorStatus)
      }
      return status
    },
    translateMultiError: (errorStatus, lang) => {
      // Sanitize input to prevent XSS
      const sanitizeString = (str) => {
        return str ? String(str).replace(/[<>"'&]/g, (match) => {
          const escapeMap = {
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '&': '&amp;'
          }
          return escapeMap[match]
        }) : ''
      }

      let status = ''
      if (lang === 'pl') {
        status = sanitizeString(errorStatus)
      } else {
        if (errorStatus && errorStatus.indexOf('<br>') >= 0) {
          const result = []
          const errorsArr = errorStatus.split('<br>')
          errorsArr.forEach(el => {
            const sanitized = sanitizeString(el)
            result.push(translate(sanitized))
          })
          status = result.join('<br>')
        } else {
          const sanitized = sanitizeString(errorStatus)
          status = translate(sanitized)
        }
      }
      return status
    },
    matrixLevelClass: level => {
      return 'level' + level
    },
    sentIcon: value => {
      return (value) ? 'fa-check' : 'fa-times'
    },
    eqStatus: kioskStatus => {
      let style
      if (kioskStatus) {
        switch (kioskStatus) {
          case 'malfunction':
            style = 'danger'
            break
          case 'operational':
            style = 'success'
            break
          case 'warning':
            style = 'warning'
            break
          case 'initializing':
            style = 'info'
            break
          case 'maintenance':
            style = 'warning'
            break
          case 'standby':
            style = 'info'
            break
        }
      }
      return style
    },
    eqStatusBtn: kioskStatus => {
      let btn = 'btn-success'
      if (kioskStatus && kioskStatus.summary) {
        if (kioskStatus.summary === 'error') {
          btn = 'btn-danger'
        } else if (kioskStatus.failureState === 'warning') {
          btn = 'btn-warning'
        } else if (kioskStatus.kiosk_status === 'standby') {
          btn = 'btn-primary'
        }
      } else if (kioskStatus) {
        switch (kioskStatus) {
          case 'malfunction':
            btn = 'btn-danger'
            break
          case 'operational':
            btn = 'btn-success'
            break
          case 'warning':
            btn = 'btn-warning'
            break
          case 'initializing':
            btn = 'btn-warning'
            break
          case 'maintenance':
            btn = 'btn-info'
            break
          case 'busy':
            btn = 'btn-primary'
            break
          case 'standby':
            btn = 'btn-primary'
            break
        }
      }
      return btn
    },
    eqStatusIcon: kioskStatus => {
      let icon = 'fa-check'
      if (kioskStatus && kioskStatus.summary) {
        if (kioskStatus.summary === 'error' || kioskStatus.failureState === 'warning') {
          icon = 'fa-exclamation-triangle'
        }
      } else if (kioskStatus) {
        switch (kioskStatus) {
          case 'malfunction':
            icon = 'fa-exclamation-triangle'
            break
          case 'operational':
            icon = 'fa-check'
            break
          case 'warning':
            icon = 'fa-exclamation-triangle'
            break
          case 'initializing':
            icon = 'fa-check'
            break
          case 'maintenance':
            icon = 'fa-check'
            break
          case 'busy':
            icon = 'fa-check'
            break
          case 'standby':
            icon = 'fa-check'
            break
        }
      }
      return icon
    },
    caps: value => {
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    uppercase: value => {
      value = value.toString()
      return value.toUpperCase()
    },
    fixed2value: obj => {
      return (obj) ? parseFloat(obj).toFixed(2) : ''
    },
    memFormat: obj => {
      return ((obj) ? parseFloat(obj).toFixed(2) : '') + ' GB'
    },
    cpuFormat: obj => {
      return ((obj) ? parseFloat(obj).toFixed(2) : '') + ' %'
    },
    tempFormat: obj => {
      // Sanitize input to prevent XSS
      const sanitized = obj != null ? String(obj).replace(/[<>"'&]/g, (match) => {
        const escapeMap = {
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          '&': '&amp;'
        }
        return escapeMap[match]
      }) : ''
      return sanitized + ' °C'
    },
    moneyFormat: val => {
      if (!val || val.length === 0) {
        return ''
      }
      return (parseInt(val, 10) / 100).toFixed(2)
    },
    screensFormat: val => {
      if (!val || val.length === 0) {
        return 'n/a'
      }
      return val.map((screen) => {
        let moreInfo = 'nieaktywny'
        if (screen.width) {
          moreInfo = `${screen.width}x${screen.height}`
        }
        return `${screen.output} (${moreInfo})`
      }).join(', ')
    },
    cookbookVersion: val => {
      try {
        return val.localConfig.kiosk.kfc_kiosk_version
      } catch (error) {
        return 'n/a'
      }
    },
    softwareFooterFormat: val => {
      try {
        const tmp = val.localConfig.kiosk.printer.footerImgPath.split('/')
        return tmp[tmp.length - 1]
      } catch (error) {
        return 'n/a'
      }
    },
    hardwareMotherboardFormat: val => {
      return (val && val.motherboard) ? `${val.motherboard.manufacturer} ${val.motherboard.productName}` : 'n/a'
    },
    hardwareCpuFormat: val => {
      return (val && val.cpu) ? val.cpu : 'n/a'
    },
    printerType: val => {
      return (val && val.printer) ? val.printer : 'n/a'
    },
    usbDevicesFormat: val => {
      const sanitizeString = (str) => {
        return str ? String(str).replace(/[<>"'&]/g, (match) => {
          const escapeMap = {
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '&': '&amp;'
          }
          return escapeMap[match]
        }) : ''
      }

      if (val && val.usbDevices) {
        if (typeof val.usbDevices[0] === 'object') {
        // if (Array.isArray(val.usbDevices) && val.usbDevices[0]) {
          return val.usbDevices.filter((line) => {
            return (!line.S || !Array.isArray(line.S) || !line.S[0].startsWith('Manufacturer=Linux'))
          }).map((obj) => {
            return Object.values(obj).flat()
          }).map((obj) => {
            return obj.map(item => sanitizeString(item)).join('<br>')
          }).join('<br><br>')
        } else {
          let show = false
          return val.usbDevices.map((line) => {
            const sanitizedLine = sanitizeString(line)
            if (line.startsWith('Manufacturer=Linux')) show = false
            if (line.startsWith('Manufacturer') && !line.startsWith('Manufacturer=Linux')) {
              show = true
              return `<strong class="usb-device-start">${sanitizedLine}</strong><br>`
            }
            if (show) return `${sanitizedLine}<br>`
          }).join('')
        }
      } else {
        return 'n/a'
      }
    }
  },
  create: (Vue) => {
    Object.keys(this.a.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.a.filters[filter])
    }.bind(this))
  }
}

function translate (str) {
  if (!str) {
    return str
  }
  if (str.indexOf('Błąd terminala: ') === 0) {
    return `Payment terminal error: ${str.substring(16)}`
  }
  const failureList = [
    {
      status_description: 'Drukarka niegotowa',
      error_type: 'printer_problem',
      en: 'Printer not ready'
    },
    {
      status_description: 'Kiosk init - Drukarka niegotowa / brak drukarki',
      error_type: 'printer_problem',
      en: 'Printer not ready / no printer'
    },
    {
      status_description: 'Drukarka niegotowa / brak drukarki',
      error_type: 'printer_problem',
      en: 'Printer not ready / no printer'
    },
    {
      status_description: 'Drukarka niegotowa',
      error_type: 'printer_problem',
      en: 'Printer not ready'
    },
    {
      status_description: 'Brak zasilania drukarki',
      error_type: 'printer_no_power',
      en: 'Printer no AC power'
    },
    {
      status_description: 'Błąd: w menu',
      error_type: 'printer_problem',
      en: 'Printer error: in menu'
    },
    {
      status_description: 'Błąd: oczekiwanie na klawisz',
      error_type: 'printer_problem',
      en: 'Printer error: waiting for keypress'
    },
    {
      status_description: 'Kiosk init - Nieprawidłowy status drukarki: oczekiwanie na klawisz: 2',
      error_type: 'printer_problem',
      en: 'Printer error: waiting for keypress: 2'
    },
    {
      status_description: 'Błąd: oczekiwanie na reakcję użytkownika',
      error_type: 'printer_problem',
      en: 'Printer error: waiting for user response'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: brak papieru – oryginał',
      error_type: 'no_paper',
      en: 'Invalid printer status: no paper'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: brak papieru - oryginał: 5',
      error_type: 'no_paper',
      en: 'Invalid printer status: no paper'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: podniesiona dźwignia',
      error_type: 'printer_problem',
      en: 'Invalid printer status: lever up'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: brak dostępu do mechanizmu',
      error_type: 'printer_problem',
      en: 'Invalid printer status: no access to mechanism'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: podniesiona pokrywa',
      error_type: 'printer_problem',
      en: 'Invalid printer status: cover open'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: brak papieru – kopia',
      error_type: 'no_paper',
      en: 'Invalid printer status: no paper - copy'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: nieodpowiednia temperatura lub zasilanie',
      error_type: 'printer_problem',
      en: 'Invalid printer status: invalid temperature or power supply'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: chwilowy zanik zasilania',
      error_type: 'printer_problem',
      en: 'Invalid printer status: temporary power failure'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: błąd obcinacza',
      error_type: 'printer_problem',
      en: 'Invalid printer status: cutter failure'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: błąd zasilacza',
      error_type: 'printer_problem',
      en: 'Invalid printer status: power supply failure'
    },
    {
      status_description: 'Nieprawidłowy status mechanizmu drukarki: podniesiona pokrywa przy obcinaniu',
      error_type: 'printer_problem',
      en: 'Invalid printer status: cover open while cutting'
    },
    {
      status_description: 'Nieprawidłowy status drukarki: oczekiwanie na reakcję użytkownika: 3',
      error_type: 'printer_problem',
      en: 'Invalid printer status: waiting for user action: 3'
    },
    {
      status_description: 'Nieprawidłowy status drukarki (błąd ostatniej komendy): 3',
      error_type: 'printer_problem',
      en: 'Invalid printer status (last command error): 3'
    },
    {
      status_description: 'Nieprawidłowy status drukarki (błąd ostatniej komendy): 12',
      error_type: 'printer_problem',
      en: 'Invalid printer status (last command error): 3'
    },
    {
      status_description: 'Nieprawidłowy status drukarki (błąd ostatniej komendy): 13',
      error_type: 'printer_problem',
      en: 'Invalid printer status (last command error): 3'
    },
    {
      status_description: 'Nieprawidłowy status drukarki: 3',
      error_type: 'printer_problem',
      en: 'Invalid printer status: 3'
    },
    {
      status_description: 'Nieprawidłowy status drukarki: 11',
      error_type: 'printer_problem',
      en: 'Invalid printer status: 11'
    },
    {
      status_description: 'Nieprawidłowy status drukarki: 13',
      error_type: 'printer_problem',
      en: 'Invalid printer status: 13'
    },
    {
      status_description: 'Warning - Mało papieru w drukarce',
      error_type: 'printer_low_paper',
      en: 'Printer low paper'
    },
    {
      status_description: 'Mało papieru w drukarce',
      error_type: 'printer_low_paper',
      en: 'Printer low paper'
    },
    {
      status_description: 'Drukarka nie odpowiada',
      error_type: 'printer_problem',
      en: 'Printer not responding'
    },
    {
      status_description: 'Otwarta pokrywa',
      error_type: 'printer_problem',
      en: 'Printer cover open'
    },
    {
      status_description: 'Brak papieru',
      error_type: 'no_paper',
      en: 'Printer cutter error'
    },
    {
      status_description: 'Błąd obcinacza',
      error_type: 'printer_problem',
      en: 'Printer cutter error'
    },
    {
      status_description: 'Brak komunikacji z kontrolerem kiosku',
      error_type: 'internal_problem',
      en: 'Kiosk controller communication error'
    },
    {
      status_description: 'Terminal nie jest gotowy',
      error_type: 'terminal_problem',
      en: 'Payment terminal not ready'
    },
    {
      status_description: 'Kiosk init - Terminal nie jest gotowy',
      error_type: 'terminal_problem',
      en: 'Payment terminal not ready'
    },
    {
      status_description: 'Terminal nie odpowiada',
      error_type: 'terminal_problem',
      en: 'Payment terminal not responding'
    },
    {
      status_description: 'Brak połączenia z terminalem',
      error_type: 'terminal_problem',
      en: 'Payment terminal connection error'
    },
    {
      status_description: 'Host Micros nieosiągalny',
      error_type: 'network_problem',
      en: 'Micros host is not available'
    },
    {
      status_description: 'Serwer aplikacji jest niedostępny',
      error_type: 'network_problem',
      en: 'Micros host is not available'
    },
    {
      status_description: 'Kiosk zablokowany raportem dobowym',
      error_type: 'daily_report',
      en: 'Kiosk is locked by daily report'
    },
    {
      status_description: 'Kiosk ma otwarte drzwiczki drukarki',
      error_type: 'kiosk_opened',
      en: 'Printer door is open'
    },
    {
      status_description: 'Kiosk ma otwarte drzwiczki kiosku',
      error_type: 'kiosk_opened',
      en: 'Kiosk door is open'
    },
    {
      status_description: 'Kiosk ma otwarte drzwiczki drukarki i kiosku',
      error_type: 'kiosk_opened',
      en: 'Kiosk and printer doors are open'
    }
  ]
  let returnVal = str
  for (let index = 0; index < failureList.length; index++) {
    const failure = failureList[index]
    if (failure.status_description === str) {
      returnVal = failure.en
    }
  }
  return returnVal
}



// WEBPACK FOOTER //
// ./src/filters.js